import React, { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { BiChevronDown } from "react-icons/bi";

import { FormField } from "components/form/FormField/FormField";
import { Checkbox } from "components/ui/Checkbox/Checkbox";

import style from "../AddVaccineForm.module.css";
import s from "./MultiSelectField.module.css";

export const MultiSelectField = ({
  name,
  label,
  options,
  placeholder = "Select",
  disabled = false,
}) => {
  const { watch, setValue } = useFormContext();
  const selectedValues = watch(name) || [];
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const handleToggle = (optionValue) => {
    const next = selectedValues.includes(optionValue)
      ? selectedValues.filter((v) => v !== optionValue)
      : [...selectedValues, optionValue];
    setValue(name, next);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const selectedLabels = options
    .filter((opt) => selectedValues.includes(opt.value))
    .map((opt) => opt.label);

  const displayText =
    selectedLabels.length > 0 ? selectedLabels.join(", ") : "";

  return (
    <div className={s.wrapper}>
      <FormField name={name}>
        <label className={style.pregnancyFormLabel}>{label}</label>
        <div
          ref={containerRef}
          className={`${s.container} ${disabled ? s.disabled : ""}`}
        >
          <button
            type="button"
            className={s.trigger}
            onClick={() => !disabled && setIsOpen(!isOpen)}
            disabled={disabled}
          >
            <span className={displayText ? s.value : s.placeholder}>
              {displayText || placeholder}
            </span>
            <BiChevronDown className={s.icon} />
          </button>
          {isOpen && (
            <div className={s.dropdown}>
              {options.map((option) => (
                <div
                  key={option.value}
                  className={s.option}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleToggle(option.value)}
                >
                  <Checkbox
                    checked={selectedValues.includes(option.value)}
                    onChange={() => {}}
                  />
                  <span className={s.optionLabel}>{option.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </FormField>
    </div>
  );
};
